export default __webpack_public_path__ + "static/media/logout.b0e7e062.png";